import { EnvironmentProviders, Provider } from '@angular/core';

import { BusinessDialogService, DateFilterService } from '@zeusm/business/core/services';
import {
  BUSINESS_DICTIONARIES_API,
  BusinessDictionariesApiMockService,
  BusinessDictionariesApiService,
  BusinessDictionariesStore,
} from '@zeusm/business/dictionaries';
import {
  SHELL_API as BUSINESS_SHELL_API,
  ShellApiMockService as BusinessShellApiMockService,
  ShellApiService as BusinessShellApiService,
  BusinessShellStore,
} from '@zeusm/business/shell';
import { environment } from '@zeusm/environment';
import { provideApiService } from '@zeusm/shared/core/helpers';
import { FILTERS_DIALOG_SERVICE } from '@zeusm/shared/core/services';

const BUSINESS_SERVICES: (Provider | EnvironmentProviders)[] = [
  BusinessDialogService,
  DateFilterService,
  { provide: FILTERS_DIALOG_SERVICE, useExisting: BusinessDialogService },
];
const BUSINESS_STORES: (Provider | EnvironmentProviders)[] = [BusinessShellStore, BusinessDictionariesStore];
const BUSINESS_API_SERVICES: (Provider | EnvironmentProviders)[] = [
  {
    provide: BUSINESS_SHELL_API,
    useClass: provideApiService(environment.useMocks, BusinessShellApiMockService, BusinessShellApiService),
  },
  {
    provide: BUSINESS_DICTIONARIES_API,
    useClass: provideApiService(environment.useMocks, BusinessDictionariesApiMockService, BusinessDictionariesApiService),
  },
];

export const BUSINESS_INFRASTRUCTURE_PROVIDERS: (Provider | EnvironmentProviders)[] = [
  ...BUSINESS_SERVICES,
  ...BUSINESS_STORES,
  ...BUSINESS_API_SERVICES,
];
